export default {"src":"/_next/static/media/bsv.828c4d27.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};